import styled from "styled-components";

export const Avancado = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;